import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getMembershipSessionPack, getMembershipsV2, getMembershipV2, getSessionHistory } from './membership.api';

export const membership = createQueryKeys('membership', {
  listV2: (params: { locationId: number; memberId: number }) => ({
    queryKey: [params],
    queryFn: () => getMembershipsV2(params),
  }),
  detailV2: (params: { locationId: number; memberId: number; membershipId: number }) => ({
    queryKey: [params],
    queryFn: () => getMembershipV2(params),
  }),
});

export const sessionPack = createQueryKeys('session-pack', {
  detail: (params: { locationId: number; memberId: number; membershipId: number }) => ({
    queryKey: [params],
    queryFn: () => getMembershipSessionPack(params),
  }),
  history: (params: { locationId: number; memberId: number; membershipId: number }) => ({
    queryKey: [params],
    queryFn: () => getSessionHistory(params),
  }),
});
